import React from "react";
import { Chip, makeStyles } from "@material-ui/core";

const labelColors = [
  "#8696a0",
  "#00a884",
  "#53bdeb",
  "#6c7cff",
  "#a56eff",
  "#d06bcb",
  "#f15c6d",
  "#f9703e",
  "#f7b928",
  "#7bc862",
  "#0086c9",
  "#5b5fc7",
  "#8e5bb7",
  "#c6538c",
  "#d64545",
  "#e07a24",
  "#c59b18",
  "#4f9d69",
  "#397f8a",
  "#667781"
];

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: 3
  },
  chip: {
    height: 20,
    marginRight: 4,
    marginBottom: 2,
    color: "#fff",
    fontSize: 11
  }
}));

const WhatsappLabels = ({ labels = [], limit = 3 }) => {
  const classes = useStyles();
  const visibleLabels = labels.slice(0, limit);
  const remaining = labels.length - visibleLabels.length;

  if (labels.length === 0) return null;

  return (
    <div className={classes.root}>
      {visibleLabels.map(label => (
        <Chip
          key={label.id}
          className={classes.chip}
          size="small"
          label={label.name}
          title={label.name}
          style={{
            backgroundColor:
              labelColors[Math.abs(Number(label.color) || 0) % labelColors.length]
          }}
        />
      ))}
      {remaining > 0 && (
        <Chip
          className={classes.chip}
          size="small"
          label={`+${remaining}`}
          title={labels.slice(limit).map(label => label.name).join(", ")}
          style={{ backgroundColor: "#667781" }}
        />
      )}
    </div>
  );
};

export default WhatsappLabels;
